// Composant pour générer les données structurées JSON-LD conformes SEO

// LocalBusiness / ProfessionalService combiné pour la page d'accueil
export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "ProfessionalService"],
  "name": "Homely Solutions Sàrl",
  "legalName": "Homely Solutions Sàrl",
  "url": "https://homely-conciergerie.ch",
  "logo": "https://homely-conciergerie.ch/logo-main.png",
  "image": "https://homely-conciergerie.ch/logo-main.png",
  "description": "Conciergerie Airbnb professionnelle et gestion locative saisonnière en Suisse romande. Commission 22% + 80 CHF/mois.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rue Jean André Venel 4",
    "addressLocality": "Yverdon-les-Bains",
    "postalCode": "1400",
    "addressRegion": "Vaud",
    "addressCountry": "CH"
  },
  "email": "info@homely-solutions.com",
  "areaServed": [
    {"@type": "City", "name": "Verbier"},
    {"@type": "City", "name": "Crans-Montana"},
    {"@type": "City", "name": "Lausanne"},
    {"@type": "City", "name": "Montreux"},
    {"@type": "City", "name": "Genève"},
    {"@type": "City", "name": "Neuchâtel"},
    {"@type": "City", "name": "Villars"},
    {"@type": "City", "name": "Yverdon-les-Bains"},
    {"@type": "City", "name": "Fribourg"},
    {"@type": "City", "name": "Vevey"},
    {"@type": "City", "name": "Sion"},
    {"@type": "City", "name": "Nyon"},
    {"@type": "City", "name": "Morges"}
  ],
  "priceRange": "CHF"
});

// Pour compatibilité avec ancien code
export const getOrganizationSchema = getLocalBusinessSchema;

// LocalBusiness spécifique pour chaque ville
export const getCityLocalBusinessSchema = (city, region, lat, lon) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": `Homely Conciergerie ${city}`,
  "description": `Conciergerie Airbnb et gestion locative saisonnière à ${city}. Commission 22% + 80 CHF/mois. Service complet : annonce, pricing dynamique, ménages, check-in, maintenance.`,
  "image": "https://homely-conciergerie.ch/logo-main.png",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": city,
    "addressRegion": region,
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": lat,
    "longitude": lon
  },
  "priceRange": "CHF",
  "areaServed": {"@type": "City", "name": city},
  "serviceType": [
    "Gestion locative saisonnière",
    "Conciergerie Airbnb",
    "Pricing dynamique",
    "Ménages professionnels",
    "Check-in/Check-out",
    "Maintenance"
  ],
  "url": `https://homely-conciergerie.ch/gestion-locative/${city.toLowerCase().replace(/\s+/g, '-')}`
});

export const getServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Gestion locative saisonnière et conciergerie Airbnb",
  "name": "Gestion Complète Airbnb",
  "description": "Service complet de conciergerie Airbnb : création d'annonce, photos professionnelles, pricing dynamique, ménages, check-in/check-out, maintenance et reporting. Commission transparente de 22% + 80 CHF par mois.",
  "provider": {
    "@type": "Organization",
    "name": "Homely Solutions Sàrl",
    "url": "https://homely-conciergerie.ch"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Suisse"
  },
  "offers": {
    "@type": "Offer",
    "description": "Commission de 22% sur les revenus locatifs + frais fixes de 80 CHF par mois",
    "price": "22% + 80",
    "priceCurrency": "CHF",
    "priceSpecification": [
      {
        "@type": "UnitPriceSpecification",
        "price": "22",
        "priceCurrency": "CHF",
        "unitText": "PERCENT",
        "referenceQuantity": {
          "@type": "QuantitativeValue",
          "value": 1,
          "unitText": "rental_revenue"
        }
      },
      {
        "@type": "UnitPriceSpecification",
        "price": "80",
        "priceCurrency": "CHF",
        "unitText": "MONTH"
      }
    ]
  }
});

export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// NE PAS utiliser AggregateRating sans avis réels vérifiables
